













import { mapState } from 'vuex';
import SidebarPanel from '@/components/sidebar/SidebarPanel.vue';

export default {
  props: {
    name: String,
    title: String,
  },
  computed: {
    ...mapState('chromeEditor', [
      'panel',
    ]),
  },
  watch: {
    panel(value: string) {
      value === this.name
        && this.$emit('display');
    },
  },
  components: {
    SidebarPanel,
  },
} as IView;
